// extracted by mini-css-extract-plugin
module.exports = {"myStoreWrapper":"BrowseAllStores_view_myStoreWrapper__3Ue5v"};